// extracted by mini-css-extract-plugin
export default {"containerBase":"ViewSwitch_containerBase__XF-R9","wrapper":"ViewSwitch_wrapper__wUvIF","active":"ViewSwitch_active__T2mH4","icon":"ViewSwitch_icon__RUs2i"};